import type { SharedApiV2 } from "@capstone/mock-api";
import { Day } from "src/app/core/day.model";
import { DashboardTicketSite } from "src/app/partner/help-assist/dashboard-help-assist-site.model";
import { HelpAssistTicketCarrier } from "src/app/partner/help-assist/models/help-assist-ticket-carrier.model";
import { DashboardTicketAppointmentOrder } from "src/app/partner/help-assist/models/ticket-appointment-draft/dashboard-ticket-appointment-order.model";

interface DeserializeArguments {
  site: DashboardTicketSite;
}

export class DashboardTicketScheduleTicketAppointment {
  private constructor(
    args: ClassProperties<DashboardTicketScheduleTicketAppointment>,
  ) {
    this.carrier = args.carrier;
    this.deliveryCarrier = args.deliveryCarrier;
    this.idealAppointmentDate = args.idealAppointmentDate;
    this.mainOrder = args.mainOrder;
    this.mainOrderNumber = args.mainOrderNumber;
    this.unknownDeliveryCarrierName = args.unknownDeliveryCarrierName;
  }

  public readonly carrier: HelpAssistTicketCarrier | null;
  public readonly deliveryCarrier: HelpAssistTicketCarrier | null;
  public readonly idealAppointmentDate: Day | null;
  public readonly mainOrder: DashboardTicketAppointmentOrder;
  public readonly mainOrderNumber: string | null;
  public readonly unknownDeliveryCarrierName: string | null;

  public static deserialize(
    apiModel: SharedApiV2.TicketAppointmentDto,
    { site }: DeserializeArguments,
  ): DashboardTicketScheduleTicketAppointment {
    return new DashboardTicketScheduleTicketAppointment({
      carrier: apiModel.carrier
        ? HelpAssistTicketCarrier.deserialize(apiModel.carrier)
        : null,
      deliveryCarrier: apiModel.deliveryCarrier
        ? HelpAssistTicketCarrier.deserialize(apiModel.deliveryCarrier)
        : null,
      idealAppointmentDate: apiModel.idealAppointmentDate
        ? Day.deserialize(apiModel.idealAppointmentDate, site.timeZone)
        : null,
      mainOrder:
        apiModel.mainOrder &&
        DashboardTicketAppointmentOrder.deserialize(apiModel.mainOrder),
      mainOrderNumber: apiModel.mainOrderNumber ?? null,
      unknownDeliveryCarrierName: apiModel.unknownDeliveryCarrier ?? null,
    });
  }
}
